import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Journeyyeppy = () => {
  return (
    <div className="journey_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={4} xl={4} xxl={4} className="my-auto">
            <h4>User Journey Maps</h4>
            <p>
              User journeys are pivotal for comprehending app interactions.
              We've meticulously mapped these journeys, highlighting
              touchpoints, interactions, and decision nodes. These maps guide us
              in designing user experiences that align with user goals,
              enhancing usability and satisfaction.
            </p>
          </Col>
          <Col xs={12} md={7} lg={8} xl={8} xxl={8}>
            <div className="maps_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/jour_maps.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1013}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Journeyyeppy;
